import type { AxiosRequestConfig } from 'axios'
import { http, upload } from '../http'
import { URL } from './_constant'

/**
 * 集体土地项目-村组协议-列表
 */
export function API_GROUP_AGREEMENT_LIST(data?: BasicPageReq) {
  return http.post<ApiGroupAgreement.ListRes>(URL.LIST, data)
}

/**
 * 集体土地项目-村组协议-全部
 */
export function API_GROUP_AGREEMENT_ALL(data?: BasicPageReq) {
  return http.post<ApiGroupAgreement.Item[]>(URL.LIST, data)
}

/**
 * 集体土地项目-村组协议-详情
 */
export function API_GROUP_AGREEMENT_DETAIL(id: string) {
  return http.post<ApiGroupAgreement.Item>(URL.DETAIL, { id })
}

/**
 * 集体土地项目-村组协议-新增
 */
export function API_GROUP_AGREEMENT_ADD(data: ApiGroupAgreement.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 集体土地项目-村组协议-删除
 */
export function API_GROUP_AGREEMENT_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  集体土地项目-村组协议-编辑
 */
export function API_GROUP_AGREEMENT_EDIT(data: BasicUpdateOneReq<ApiGroupAgreement.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  集体土地项目-村组协议-禁用
 */
export function API_GROUP_AGREEMENT_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 集体土地项目-村组协议-启用
 */
export function API_GROUP_AGREEMENT_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 集体土地项目-村组协议-排序
 */
export function API_GROUP_AGREEMENT_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 集体土地项目-村组协议-导入模板下载
 */
export function API_GROUP_AGREEMENT_TPL() {
  return http.post<ImportTemplateRes>(URL.TPL)
}

/**
 * 集体土地项目-村组协议-导入
 */
export function API_GROUP_AGREEMENT_IMPORT(file: File, projectId: string, config: AxiosRequestConfig = {}) {
  return upload(URL.IMPORT, { file, data: { projectId } }, config)
}
